<template>
  <div class="group-list">
    <router-link to="/group/create">
      <el-button type="primary" class="m-2">添加群</el-button>
    </router-link>
    <el-table :data="list" v-loading="isLoading">
      <el-table-column
        prop="img"
        label="图片"
      >
        <template slot-scope="scope"><img :src="scope.row.img|ossurl" alt=""
            :style="{
              width: '80px',
              height: 'auto',
              margin: '10px 0 0 0'
            }"
          ></template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="俱乐部名"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.status===1">待审核</el-tag>
          <el-tag type="success" v-if="scope.row.status===2">上线</el-tag>
          <el-tag type="warning" v-if="scope.row.status===3">下线</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作"
      >
        <template slot-scope="scope">
          <router-link :to="'/group/'+scope.row.id">
          <el-button type="text">编辑</el-button>
        </router-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getShopList } from '@/api/shop'

export default {
  name: 'page-list',
  data () {
    return {
      isLoading: false,
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList (page = 1, size = 10) {
      this.isLoading = true
      const { shops } = await getShopList(7)
      this.list = shops
      this.isLoading = false
    }
  }
}
</script>




// WEBPACK FOOTER //
// group-list.vue?93e4d10c